// src/routes/index.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import LandingPage from '../components/landing-page/landing-page';
import App from '../App';
import BlogPage from '../components/blog/blog';
import BlogPost from '../components/blog/BlogPost';
import SuccessStories from '../components/success-stories/success-stories';
import HowToUsePage from '../components/how-to-use/how-to-use';
import AdminPage from '../components/admin/AdminPage';
import TermsPage from '../components/legal/TermsPage';
import Index from '../components/legal';
import AffiliateDashboard from '../components/affiliate/AffiliateDashboard';
import ResetPassword from '../components/auth/ResetPassword';

// --- MAILING LIST ---
import MailingListSignup from '../components/mailing-list/MailingListSignup';

// --- SEASONAL KEYWORD PAGES ---
import MothersDay2026 from '../components/seasonal/MothersDay2026';
import April2026 from '../components/seasonal/April2026';
import May2026 from '../components/seasonal/May2026';
import CincoDeMayo2026 from '../components/seasonal/CincoDeMayo2026';
import BackToSchool2026 from '../components/seasonal/BackToSchool2026';
import August2026 from '../components/seasonal/August2026';

function Navigation() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/app" element={<App />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/case-studies" element={<SuccessStories />} />
      <Route path="/how-to-use" element={<HowToUsePage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/privacy-policy" element={<Index />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/affiliate" element={<AffiliateDashboard />} />
      <Route path="/affiliate-dashboard" element={<AffiliateDashboard />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* --- MAILING LIST --- */}
      <Route path="/mailing-list-signup" element={<MailingListSignup />} />

      {/* --- SEASONAL KEYWORD PAGES --- */}
      <Route path="/keywords/mothers-day-2026" element={<MothersDay2026 />} />
      <Route path="/keywords/april-2026" element={<April2026 />} />
      <Route path="/keywords/may-2026" element={<May2026 />} />
      <Route path="/keywords/cinco-de-mayo-2026" element={<CincoDeMayo2026 />} />
      <Route path="/keywords/back-to-school-2026" element={<BackToSchool2026 />} />
      <Route path="/keywords/august-2026" element={<August2026 />} />
    </Routes>
  );
}

export default Navigation;